import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { TweenConstants } from "@lib/titan2-slingo/dist/game/view/abstract/constant/TweenConstants";
import { WinDisplay } from "@lib/titan2-slingo/dist/game/view/abstract/display/WinDisplay";
import { MouseBlocker } from "@lib/titan2/dist/game/control/MouseBlocker";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
/**
 * GameWinDisplay.ts
 */
export class GameWinDisplay extends WinDisplay {
    constructor(factory, landscapeProperties, portraitProperties) {
        super(factory, landscapeProperties, portraitProperties);
        this.landscapeProperties = landscapeProperties;
        this.portraitProperties = portraitProperties;
        this.mouseBlocker = new MouseBlocker(new MouseBlockerProperties(0x000000, 0.6));
    }
    addEventListeners() {
        super.addEventListeners();
        this.unregisterGame(SlingoEvent.SLINGO);
        this.registerGame(SlingoEvent.SLINGO_WIN_ANIMATION, this.handleSlingo);
    }
    handleSlingoAnimationComplete() {
        this.dispatchGame(SlingoEvent.SLINGO_WIN_ANIMATION_COMPLETE);
    }
    startSummary() {
        this.dispatchGame(SlingoEvent.GAME_SUMMARY);
        this.summary.play();
        this.mouseBlocker.alpha = 0;
        gsap.to(this.mouseBlocker, { alpha: 1, duration: TweenConstants.DEFAULT_OVERLAY_FADE_DURATION });
        this.addChildAt(this.mouseBlocker, 0);
        this.addChild(this.summary);
    }
    startGameOver() {
        this.summary.update();
        this.startSummary();
    }
    handleGameComplete() {
        gsap.to(this.mouseBlocker, { alpha: 0, duration: TweenConstants.DEFAULT_OVERLAY_FADE_DURATION, onComplete: () => this.removeChild(this.mouseBlocker) });
        super.handleGameComplete();
    }
    handleReelsComplete() {
        //noop
    }
}
//# sourceMappingURL=GameWinDisplay.js.map